import Cookies from 'js-cookie'

interface CookieOptions {
  expires: number
  sameSite: 'Lax' | 'Strict' | 'None'
  secure?: boolean
}

export function removeCookieForBothDomains(name: string, options: Omit<CookieOptions, 'secure'>): void {
  Cookies.remove(name, { ...options, domain: '.fjordline.com' })
  Cookies.remove(name, { ...options, domain: '.fjordline.no' })
  Cookies.remove(name, { ...options, domain: 'fjordline.no' })
  Cookies.remove(name, { ...options, domain: 'fjordline.com' })
}

export function setCookieForBothDomains(name: string, value: string, options: CookieOptions): void {
  Cookies.set(name, value, { ...options, domain: '.fjordline.com' })
  Cookies.set(name, value, { ...options, domain: '.fjordline.no' })
  Cookies.set(name, value, { ...options, domain: 'fjordline.no' })
  Cookies.set(name, value, { ...options, domain: 'fjordline.com' })
}
